import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
const routes: Array<RouteRecordRaw> = [
  {
    path: '/facilita-rgpd',
    name: 'Facilita RGPD',
    component: () => import(/* webpackChunkName: "Facilita RGPD" */ '../views/FacilitaRGPD/FacilitaRGPD.vue'),
    meta: {
      i18nKey: 'facilita-rgpd',
      icon: require('@/assets/img/facilita-rgpd.svg'),
      iconDark: require('@/assets/img/facilita-rgpd-dark.svg'),
      title: 'facilita-rgpd.title',
      description: 'facilita-rgpd.description'
    }
  },
  {
    path: '/comunica-brecha',
    name: 'Comunica Brecha',
    component: () => import(/* webpackChunkName: "Comunica Brecha" */ '../views/ComunicaBrecha/ComunicaBrecha.vue'),
    meta: {
      i18nKey: 'comunica-brecha',
      icon: require('@/assets/img/comunica-brecha.svg'),
      iconDark: require('@/assets/img/comunica-brecha-dark.svg'),
      title: 'comunica-brecha.title',
      description: 'comunica-brecha.description'
    }
  },
  {
    path: '/asesora-brecha',
    name: 'Asesora Brecha',
    component: () => import(/* webpackChunkName: "Comunica Brecha" */ '../views/AsesoraBrecha/AsesoraBrecha.vue'),
    meta: {
      i18nKey: 'asesora-brecha',
      icon: require('@/assets/img/asesora-brecha.svg'),
      iconDark: require('@/assets/img/asesora-brecha-dark.svg'),
      title: 'asesora-brecha.title',
      description: 'asesora-brecha.description'
    }
  },
  {
    path: '/facilita-emprende',
    name: 'Facilita Emprende',
    component: () => import(/* webpackChunkName: "Facilita Emprende" */ '../views/FacilitaEmprende/FacilitaEmprende.vue'),
    meta: {
      i18nKey: 'facilita-emprende',
      icon: require('@/assets/img/facilita-emprende.svg'),
      iconDark: require('@/assets/img/facilita-emprende-dark.svg'),
      title: 'facilita-emprende.title',
      description: 'facilita-emprende.description'
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const host = window.location.host;

  const isDes = host.includes('-des');
  const isCer = host.includes('-cer');
  const isPro = host.includes('-pro');
  const isAkadru = host.includes('akadru');
  const isPropub = host.includes('.aepd.es');

  if (isDes || isCer || isPro || isAkadru || isPropub) {
    if ((host.includes('facilitargpd') || host.includes('akadru-facilita') || (host.includes('facilita') && !host.includes('emprende'))) && to.name !== 'Facilita RGPD') {
      next({ name: 'Facilita RGPD' });
    } else if ((host.includes('facilitaemprende') || host.includes('akadru-emprende') || host.includes('emprende')) && to.name !== 'Facilita Emprende') {
      next({ name: 'Facilita Emprende' });
    } else if ((host.includes('comunicabrecha') || host.includes('akadru-comunica') || host.includes('comunica')) && to.name !== 'Comunica Brecha') {
      next({ name: 'Comunica Brecha' });
    } else if ((host.includes('asesorabrecha') || host.includes('akadru-asesora') || host.includes('asesora')) && to.name !== 'Asesora Brecha') {
      next({ name: 'Asesora Brecha' });
    } else {
      next();
    }
  } else {
    next();
  }  
});

router.afterEach(() => {
window.history.replaceState(null, '', window.location.origin); 
});
export default router;
